import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styles from "./ArchiveHeader.module.scss";

type Props = {
  openModal: () => void;
  searchConditionCount: number;
};
const AdvancedSearchButton: React.FC<Props> = ({
  openModal,
  searchConditionCount,
}) => {
  return (
    <div className={styles["search-toggle"]} onClick={openModal}>
      <FontAwesomeIcon icon={["fal", "search"]} />
      条件で絞り込む
      {searchConditionCount > 0 ? <span>{searchConditionCount}</span> : null}
    </div>
  );
};

export default AdvancedSearchButton;
